// components
import{ByTag}from'components/v2/Filters/MultiSelect';var filters=[ByTag];export default filters;